import db from '../db';

const local_executions = db.table('local_executions');
const executions = db.table('executions');

async function getAllExecutions() {
  try {
    return await local_executions.toArray();
  } catch (error) {
    throw error;
  }
}

async function getOneExecution(id) {
  try {
    let local_exec = await local_executions.get({id: Number(id)});
    return local_exec 
  } catch (error) {
    throw error
  }
}

async function createExecution(execution) {
  try {
    return await local_executions.add({...execution});
  } catch (error) {
    throw error;
  }
}

async function updateOneExecution(execution) {
  try {
    await local_executions.put({...execution});
    return execution;
  } catch (error) {
    throw error
  }
};

export default {
  getAllExecutions,
  getOneExecution,
  updateOneExecution,
  createExecution
};